export default __webpack_public_path__ + "static/media/refactai.9bff5752.png";